
import { BrowserRouter as Router } from 'react-router-dom';
import Routess from './Routes';

function App() {
  return (
    <Router>
      <Routess />
    </Router>
  );
}

export default App;
